import React, { useState } from "react";
import { useUserSubscription } from "../../helper/hooks";
import "./diwali-merch-page.m.css";
import { SubscriberOnlyNudge } from "./subscriber-only-nudge";

export function DiwaliMerchPage() {
  const userSubscription = useUserSubscription();
  const [showDialog, setShowDialog] = useState(false);
  const subscriptionLoading = userSubscription.loading;
  const userHasSubscription = userSubscription.userHasSubscription;

  const handleBuyNow = planId => () => {
    if (userHasSubscription) {
      window.open(`https://razorpay.com/payment-button/${planId}/view`, "_blank");
    } else {
      setShowDialog(true);
    }
  };

  return (
    <div styleName="offer-container">
      <h1>Newslaundry Festive Season Hamper</h1>
      <div style={{ textAlign: "center" }}>
        <img
          style={{ maxHeight: "480px", marginBottom: "20px" }}
          alt="banner"
          src="https://images.assettype.com/newslaundry/2020-11/75ca543e-3110-488a-93f3-10e21d557776/christmas_diwali_english.jpg"
        />
      </div>

      <p>The victory of good over evil;</p>
      <p>Redemption and salvation;</p>
      <p>Or simply turning over a new leaf in the New Year;</p>
      <br />
      <p>We celebrate festivals for a number of reasons. This year, Newslaundry is adding one more to this list:</p>
      <br />
      <p>
        <strong>
          <i>The spirit of independent journalism.</i>
        </strong>
      </p>
      <br />
      <p>
        Get this merchandise for yourself and say you’re a proud member of a community that keeps independent media
        alive,
        <br />
        or gift these to friends and family, and spread the word about free, accurate, and independent news (and let’s
        face it, we could all do with a little less of that mithai in the house).
      </p>

      <div styleName="hamper__container">
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Package One</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2020-11/564a6897-2170-437b-ac22-7073100c96db/Package_1.png"
          />
          <hr />
          <ul>
            <li>NL Sabki Dhulai Soap Box Set</li>
            <li>NL Scented Candle</li>
            <li>Gift a 1 month NL subscription</li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>1,099
          </h2>
          {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_Fv6aJyOXLdyBnV")}>Buy Now</button>
          )}
        </div>
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Package Two</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2020-11/ff6b3f5b-df41-4862-b8a9-ed952249a0f4/Package_2.png"
          />
          <hr />
          <ul>
            <li>NL Sipper</li>
            <li>NL Tote Bag</li>
            <li>NL Mug - &quot;Which Naxal Are You?&quot;</li>
            <li>Gift a 1 month NL subscription</li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>999
          </h2>
          {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_FwBIqpEbSbCwSX")}>Buy Now</button>
          )}
        </div>
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Package Three</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2020-11/52187f30-9c55-493a-bce9-1a55b96dbd60/Package_3.png"
          />
          <hr />
          <ul>
            <li>NL Sabki Dhulai Soap Box Set</li>
            <li>NL Scented Candle</li>
            <li>NL Sipper</li>
            <li>NL Tote Bag</li>
            <li>Gift a 3 month NL subscription</li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>1,999
          </h2>
          {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_FwBNA3o6fYYUPh")}>Buy Now</button>
          )}
        </div>
      </div>
      <div>
        <div>
          <strong>Terms &amp; Conditions</strong>
        </div>
        <br />
        <ul styleName="notes_wrapper">
          <li>This is a limited period offer from November 4, 2020 to January 2, 2021.</li>
          <li>The merchandise can be purchased by active Newslaundry subscribers only</li>
          <li>Delivery in India only. </li>
          <li>If you are based overseas, please share an Indian delivery address (of friends/family).</li>
          <li>Please note, delivery of packages will take at least two to three weeks. Please be patient with us.</li>
          <li>We will manually map the subscription gifted. The subscription will be mapped within 48 hours.</li>
          <li>The product images shown may not be an exact representation of the product.</li>
          <li>
            If you have any queries, please drop an email on{" "}
            <a style={{ color: "#ec2227" }} href="mailto:store@newslaundry.com">
              store@newslaundry.com
            </a>
          </li>
        </ul>
      </div>
      {showDialog ? <SubscriberOnlyNudge handleClose={() => setShowDialog(false)} /> : null}
    </div>
  );
}
